export const RawColors = {
    DarkDenim: '#0C1533',
    BlueCyan: '#3bb3c2',
    BlueLightSky: '#B4DAE0',
    BlueIndigo: '#2E424A',
    BlueSteel: '#58838C',
    BlueAlice: '#F3F9FA',
    Malachite: '#00CE62',
    Amaranth: '#E72D59',
    AmericanYellow: '#EAB600',
    AmericanViolet: '#4A148C',
    SpanishGray: '#949494',
    CadetBlue: '#A9BAC1',
    ChineseSilver: '#C5CCD0',
    White: '#ffffff',
    Black: '#000000',
    AntiFlashWhite: '#E9F5F780',
    BrightGray: '#EEEEEE'
} as const

export const Styles = {
    BorderRadius: '25px',
    BorderRadiusSM: '10px',
    BoxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.05)',
    BoxShadowSM: '0px 2px 5px 0px rgba(0, 0, 0, 0.05)',
    Gap: '10px'
} as const

export const Colors = {
    Primary: RawColors.DarkDenim,
    Secondary: RawColors.BlueAlice,
    Info: RawColors.White,
    Danger: RawColors.Amaranth,
    PrimaryBackground: RawColors.White,
    SecondaryBackground: RawColors.AntiFlashWhite,
    SuccessColor: RawColors.BlueCyan,
    DisabledBackground: RawColors.ChineseSilver,
    DisabledColor: RawColors.White,
    DefaultTextColor: RawColors.Black,
    DangerTextColor: RawColors.Amaranth,
    BorderColor: RawColors.SpanishGray,
    SecondaryTextColor: RawColors.SpanishGray,
    CardHeaderColor: RawColors.BlueIndigo,
    MenubarBackground: RawColors.BrightGray
} as const